var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.23,
    height: 12.77,
    viewBox: "0 0 25.23 12.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "show_pw_icon",
    "data-name": "show pw icon",
    transform: "translate(-64.921 -29.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25532",
    "data-name": "Path 25532",
    d: "M40.536,22.672c-6.967,0-12.615,6.385-12.615,6.385s5.648,6.385,12.615,6.385,12.615-6.385,12.615-6.385S47.5,22.672,40.536,22.672Zm0,10.837a4.452,4.452,0,1,1,4.452-4.452A4.452,4.452,0,0,1,40.536,33.509Z",
    transform: "translate(37 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25533",
    "data-name": "Path 25533",
    d: "M355.333,133.712a3.141,3.141,0,1,0,3.141,3.141A3.141,3.141,0,0,0,355.333,133.712Zm0,2.61a1.138,1.138,0,1,1,1.138-1.138A1.138,1.138,0,0,1,355.333,136.322Z",
    transform: "translate(-277.797 -100.796)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/show-icon.8ecb392df56d03c907990276ec7195ae.svg";
export { ForwardRef as ReactComponent };